import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { getAppInfo } from '../utils/api/info_api';

// The value bs-food's APP_ENVIRONMENT carries in production, as the configmap
// in bs-eks-deployment spells it.
const PRODUCTION = 'prod';

const useStyles = makeStyles((theme) => ({
  version: {
    color: theme.palette.text.main,
    fontSize: 14,
    whiteSpace: 'nowrap',
  },
}));

export const formatAppVersion = (info) => {
  const version = info?.build?.version;
  if (!version) return null;
  const environment = info.environment;
  if (!environment || environment === PRODUCTION) return version;
  return `${environment} - ${version}`;
};

/**
 * Asks the backend once, on mount. A failure leaves the footer without a
 * version: the panel works the same without it, and a dialog for a line in the
 * footer would be noise on every page the backend is slow to answer.
 */
const useAppInfo = () => {
  const [info, setInfo] = useState(null);

  useEffect(() => {
    let cancelled = false;

    getAppInfo()
      .then((data) => {
        if (!cancelled) setInfo(data);
      })
      .catch(() => {
        // Nothing to show, nothing to report: see the docstring.
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return info;
};

/**
 * Version and environment of the backend, for the footer. Renders nothing
 * until the backend answers, and nothing at all when it does not.
 */
const AppVersion = ({ className }) => {
  const classes = useStyles();
  const label = formatAppVersion(useAppInfo());

  if (!label) return null;

  return (
    <Typography
      component="span"
      className={
        className ? `${classes.version} ${className}` : classes.version
      }
    >
      {label}
    </Typography>
  );
};

AppVersion.propTypes = {
  className: PropTypes.string,
};

export default AppVersion;
